import React, { useEffect, useState } from "react";
import "./Gift_By_Occassion.css";
import Common_breadcrumb from "../../common_components/common_breadcrumb/Common_breadcrumb";
import Celebrate_The_Festival from "./celebrate_the_festival/Celebrate_The_Festival";
import Other_Festival from "./other_festival/Other_Festival";
import { occasion } from "../../../utils/apis/Home/Homeapi";
import { Website_Type } from "../../../utils/common";
import { luxuryGiftOccassion } from "../../../utils/luxuryapis/Home/Homeapi";

const Gift_By_Occassion = () => {
  const breadcrumbItems = [
    { label: "HOME", link: "/luxury/home" },
    { label: "GIFT BY OCCSASSION" },
  ];
  const [occasions, setOccasions] = useState([]);
  const [giftoccassions, setGiftOccasions] = useState([]);

  const getOccasions = async () => {
    const res = await occasion(Website_Type.Luxury);
    if (res?.success) setOccasions(res.data);
  };
  useEffect(() => {
    getOccasions();
  }, []);

  const getAllLuxuryGiftOccassion = async () => {
    const res = await luxuryGiftOccassion();
    if (res?.success) {
      setGiftOccasions(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllLuxuryGiftOccassion();
  }, []);

  return (
    <section className="Gift_By_Occassion">
      <div className="custom_container">
        <Common_breadcrumb items={breadcrumbItems} />
        {giftoccassions?.map((val) => (
          <Celebrate_The_Festival
            occasions={occasions}
            giftoccassions={val}
          />
        ))}

        {/* <Other_Festival occasions={occasions} giftoccassions={giftoccassions} /> */}
      </div>
    </section>
  );
};

export default Gift_By_Occassion;
